const i = (e, l) => {
  if (!e || !l)
    return null;
  const o = e == null ? void 0 : e.toLowerCase().indexOf(l.toLowerCase());
  if (o === -1)
    return null;
  const n = o + l.length;
  let c = n;
  const t = e.slice(n).indexOf(" ");
  return t === -1 ? e.slice(n, e.length) : e.slice(n, c + t);
};
export {
  i as default
};
